import React from 'react';
import { Link } from 'react-router-dom';
import { ManageAssets_NavLink_To } from '../../Constants/AppBar';
import { IconButton, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	manageAssetPageLink: {
		'& svg': {
			verticalAlign: 'middle',
		},
		textDecoration: 'none',
	},
	linkText: {
		color: theme.palette.primary.main,
	},
}));
// Manage asset navigation in new window component.
const ManageAssetInNewTabLink = ({ assetUUID, linkTxt, icon }) => {
	const classes = useStyles();
	if (assetUUID) {
		// opening manage asset page in new tab when link is clicked. in case of existing asset name error.
		return (
			<Link
				to={ManageAssets_NavLink_To + '/' + assetUUID}
				className={classes.manageAssetPageLink}
				target="_blank"
				color="primary"
			>
				<IconButton color="primary" size="small">
					{icon ?? icon}
					<span className={classes.linkText}>{linkTxt}</span>
				</IconButton>
			</Link>
		);
	}
	return null;
};

export default ManageAssetInNewTabLink;
